import React from 'react';

import { imageCdnAsset } from 'lib/common/url-helpers';

import AppLink from 'containers/common/app-link';

const MobileAppBanner = () => (
  <div className="mobile-app-banner hidden-xs">
    <div className="col-sm-2 padding-right-0 app-button">
      <AppLink appStore="apple" linkProps={{ c: 'banner_popup' }} className="app-link" title="Apple App Store">
        <img className="app-icon" src={imageCdnAsset('/images/buttons/apple-store.png')} alt="Apple App Store" />
      </AppLink>
    </div>
    <div className="col-sm-2 padding-right-0 app-button">
      <AppLink appStore="android" linkProps={{ c: 'banner_popup' }} className="app-link" title="Android Google Play">
        <img className="app-icon bordered" src={imageCdnAsset('/images/buttons/play-store.png')} alt="Android Google Play" />
      </AppLink>
    </div>
    <div className="col-sm-8" />
  </div>
);
export default MobileAppBanner;
